<div class="sticky">
  <div class="header-flex">
    <div class="flex-gauche">
      <img class="img-logo" src="assets/logos/logo.png" alt="" (click)="redirection_accueil()" />
      <div class="head-text">MOUVRH : demande de recrutement et renouvellement</div>
    </div>

    <div class="flex-droite">
      @if (demanteToValidateObservable$ | async; as demanteToValidate) {
        <mat-icon
          matTooltip="Demandes en attente de validation/avis"
          [matBadge]="demanteToValidate.total"
          [matMenuTriggerFor]="menuNotification"
          matBadgeColor="warn"
          class="icon-helper hidden-xs notification yellow"
          aria-hidden="false"
          style="cursor: pointer"
          >notifications</mat-icon
          >
          <mat-menu #menuNotification="matMenu" class="connexionMenu border-yellow" style="width: 500px !important">
            <div style="border-top: 2px solid #ffc107 !important; width: auto"></div>
            <div style="padding: 1rem">
              @if (isValidateur) {
                <div class="mb-3" style="color: #758589; font-size: 14px; font-weight: 500">
                  Vous avez <span style="color: #f44336">{{ demanteToValidate.totalDemandeToValidate }}</span> demandes de
                  Recrutement/Renouvellement à valider
                </div>
                <div class="mb-15" style="margin-left: 20px; font-size: 14px">
                  <a (click)="redirectNotification()">
                    >
                    <span style="font-weight: bold"> {{ demanteToValidate.numberRecrutementToValidate }}</span> Demandes de Recrutement en
                    attente de validation</a
                    ><br />
                    <a (click)="redirectNotificationRenouvellement()">
                      > <span style="font-weight: bold">{{ demanteToValidate.numberRenouvellementToValidate }}</span> Demandes de Renouvellement
                      en attente de validation</a
                      >
                    </div>
                    <mat-divider class="mx-3" style="border-top: 1px solid black"></mat-divider>
                  }
                  <div [ngClass]="{ 'my-3': isValidateur, 'mb-3': !isValidateur }" style="color: #758589; font-size: 14px; font-weight: 500">
                    Vous avez <span style="color: #f44336">{{ demanteToValidate.totalDemandeAvis }}</span> demandes d'avis à traiter
                  </div>
                  <div style="margin-left: 20px; font-size: 14px">
                    @if (demanteToValidate.totalDemandeAvis && demanteToValidate.totalDemandeAvis > 0) {
                      @if (demanteToValidate.numberRecrutementAvis && demanteToValidate.numberRecrutementAvis > 0) {
                        <a style="text-decoration: none; cursor: pointer" [routerLink]="['/pama/demande-avis-list']">
                          > <span style="font-weight: bold"> {{ demanteToValidate.numberRecrutementAvis }} </span> Demandes d'avis de Recrutement
                          en attente de traitement<br />
                        </a>
                      }
                      @if (demanteToValidate.numberRenouvellementAvis && demanteToValidate.numberRenouvellementAvis > 0) {
                        <a style="text-decoration: none; cursor: pointer" [routerLink]="['/pama/demande-avis-list']">
                          > <span style="font-weight: bold"> {{ demanteToValidate.numberRenouvellementAvis }} </span> Demandes d'avis de
                          Renouvellement en attente de traitement<br />
                        </a>
                      }
                    }
                  </div>
                </div>
                <div style="border-bottom: 2px solid #ffc107 !important; width: auto"></div>
              </mat-menu>
            }

            <div>
              <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" class="button-helper user-button" color="primary">
                <mat-icon class="material-symbols-outlined icon-compte">account_circle</mat-icon>
                <div class="texte-utilisateur">{{ name }}</div>

                <mat-menu #menu="matMenu" class="connexionMenu">
                  <div class="connexion-titre">
                    Dernière connexion le {{ (currentAgent$ | async)?.dateDerniereConnexion | date: 'dd/MM/yyyy à HH:mm' }}
                    <br />
                    Profil applicatif : {{ roleApplicatif }}
                  </div>

                  <div class="div-bouton" (click)="$event.stopPropagation()">
                    <div class="div-bt-element div-bt-element-1" (click)="manageUserDelegations()">
                      <button type="button" class="bt-deleguer">
                        <mat-icon class="deleguer-icon"> supervisor_account </mat-icon> Gérer mes délégations
                      </button>
                    </div>
                    <div class="div-bt-element-dcn div-bt-element-3">
                      <button type="button" class="bt-deconnexion" (click)="logout()">
                        <mat-icon class="logout-icon"> power_settings_new </mat-icon> Se déconnecter
                      </button>
                    </div>
                    <div class="text-align-left ml-10" style="font-size: 12px; color: gray; pointer-events: none">V{{ version }}</div>
                  </div>
                </mat-menu>
              </button>
            </div>
          </div>
        </div>
      </div>
